import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuelidate from 'vuelidate';
import store from './ClientApp/store';
import "./ClientApp/helpers/interceptors";
import autofocus from 'vue-autofocus-directive';

import "bootstrap/dist/css/bootstrap.min.css";

Vue.use(Vuelidate);
Vue.directive('autofocus', autofocus);
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js